import { loadStripe } from '@stripe/stripe-js';

const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  console.warn('Stripe publishable key not configured. Set REACT_APP_STRIPE_PUBLISHABLE_KEY in .env');
}

const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null;

export default stripePromise;
